import { type GameWinnerTileKeyReturn, gameWinnerTileKey } from '@game/types'
import { inject } from '#imports'

export const useGameWinnerTile = () => {
    return inject(gameWinnerTileKey) as GameWinnerTileKeyReturn
}
